<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi">For</p>
<p class="dedia">my beaus,</p>
<p class="dedib">Samuel Brown</p>
<p class="dedia">Fred Bryant</p>
<p class="dedia">Oscar Byrd</p>
<p class="dedia">Malik Dawkins</p>
<p class="dedia">Seth Fallen</p>
<p class="dedia">Anthony Glover</p>
<p class="dedia">Aaron Heyward</p>
<p class="dedia">Dorian Lee</p>
<p class="dedia">Angelo Matos</p>
<p class="dedia">Brandon Roberts</p>
<p class="dedia">Zachary Shelton</p>
<p class="dedia">Cedric Trussell</p>
<p class="dedib">You are true gentlemen destined for greatness.</p>
<p class="dedia">Stay on your knees so that God can take you soaring!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedi.vue?66b9e014